<template>
        <div class="max-w-content">
            <div class="header-branch-box"><p class="title">{{componentTitle}}</p></div>
            <input type="text" placeholder="Введите название ветки" v-model="branch.title" class="form-control large-size-inp branch-title">
            <div class="check-lists checkbox-view can-drag large-indent">
                    <draggable v-model="branch.lists" class="dragArea" v-bind="getOptions" handle=".handle">
                        <div class="check-list-item-row" v-for="(list, key) in branch.lists" :key="key">
                            <div class="check-list-item-box ">
                                <div class="checkbox-item" v-if="controlType === COPY_BRANCH">
                                    <input :id="'item-'+ list.id" v-model="list.checked" type="checkbox"/>
                                    <label :for="'item-'+ list.id"></label>
                                </div>
                                <div class="data-box">
                                    <p class="title">{{list.title}}</p>
                                </div>
                                <controls-dropdown  v-if="controlType === EDIT_BRANCH" :actions="personalActionsList" :visible-controls="visibleControlsId" :item-id="list.id" @click="clickControls"></controls-dropdown>
                                <span class="draggable-icon handle">
                                    <icon-base width="10" height="16" viewBox="0 0 10 16"><icon-drag/></icon-base>
                                </span>
                            </div>
                        </div>
                    </draggable>
                <span v-show="$_.isEmpty(activeList)" @click="closeEdit" title="Закрыть" class="js-hide-branch-component">
                    <icon-base width="14" height="14" viewBox="0 0 14 14"><icon-close/></icon-base>
                </span>
            </div>
            <div class="branch-btns-box" :class="(!$_.isEmpty(activeList) || loading) ? 'disabled' : ''">
                <div class="sub-box">
                    <a href class="btn transparent" @click.prevent="addClick">Добавить чек-листы из других веток</a>
                    <a href type="button" @click.prevent="saveClick" class="btn">{{controlType === COPY_BRANCH ? 'Создать ветку' : 'Сохранить'}}</a>
                </div>
            </div>
        </div>
</template>

<script>
    import ControlsDropdown from "../MainPage/ControlsDropdown";
    import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
    import draggable from 'vuedraggable';
    import CompleteComponent from "../common/CompleteComponent";
    import {EDIT_BRANCH, COPY_BRANCH, CREATE_BRANCH, NOTIFICATION_WARNING} from '../../constants/common'
    import IconBase from "../common/IconBase";
    import IconClose from "../common/icons/IconClose";
    import IconDrag from "../common/icons/IconDraggable";


    export default {
        name: 'edit-branch',
        components: {
            IconBase,
            IconClose,
            IconDrag,
            ControlsDropdown,
            draggable
        },
        props: {
            //post: Object,
        },
        computed: {
            ...mapState({
                controlType: state => state.checkLists.controlType,
                commonBranch: state => state.checkLists.common,
                activeBranch: state => state.checkLists.activeBranch,
                visibleControlsId: state => state.checkLists.visibleControlsId,
                activeList: state => state.checkLists.activeList
            }),
            ...mapGetters('checkLists', [
                'getPersonalBranch'
            ]),
            getBranch() {
                return this.$store.state.checkLists.personal.find((x => x.id === this.activeBranch))
            },
            componentTitle() {
                switch(this.controlType) {
                    case EDIT_BRANCH:
                        return 'Редактирование';
                    case COPY_BRANCH:
                        return 'Копирование';
                    case CREATE_BRANCH:
                        return 'Создание ветки';
                    default:
                        return 'Редактирование';
                }
            },
            getOptions() {
                return {
                    animation: 200,
                    forceFallback: true
                }
            },
            branch: {
                get() {
                    return this.activeBranch
                },
                set(value) {
                    this.$store.commit('checkLists/setPersonalLists',  value)
                }
            },
        },
        data () {
            return {
                loading: false,
                personalActionsList: [
                    /*{
                        title: 'Редактировать',
                        action: 'checkLists/editBranch'
                    },
                    {
                        title: 'Копировать',
                        action: 'checkLists/copyBranch'
                    },
                    {
                        title: 'В избранное',
                        action: 'copy'
                    },*/
                    {
                        title: 'Удалить',
                        action: 'checkLists/deleteList',
                        needConfirm: true,
                    },
                ],
                EDIT_BRANCH: EDIT_BRANCH,
                COPY_BRANCH: COPY_BRANCH
            }
        },
        methods: {
            ...mapMutations('checkLists', [
                'setControlsVisibility',
                'closeEdit',
                'setActiveList'
            ]),
            ...mapActions('checkLists', [
                'saveBranch',
                'pushBranch',
            ]),
            ...mapActions([
                'switchPopup'
            ]),
            ...mapMutations([
                'setPopupComponent',
                'setPopupData',

            ]),
            clickControls(e) {
                if (this.visibleControlsId !== e) {
                    this.setControlsVisibility(e);
                } else {
                    this.setControlsVisibility(null);
                }
            },
            saveClick() {
                if (!this.branch.title.length) {
                    this.$store.dispatch('pushNotification', {text: "Укажите название ветки", type: NOTIFICATION_WARNING, time: 3000});
                    return false
                }
                this.loading = true;
                if (this.controlType === EDIT_BRANCH) {
                    this.saveBranch().then(() => {
                        this.loading = false;
                        this.closeEdit();
                    })
                } else {
                    this.pushBranch().then(() => {
                        this.loading = false;
                        this.closeEdit();
                        this.setPopupComponent(CompleteComponent);
                        this.setPopupData({msg: "Ветка чек-листов успешно создана!"});
                        this.switchPopup(true);

                    })
                }
            },
            addClick() {
                this.setActiveList({1:{}});
            }
        }
    }
</script>

<style scoped>

</style>
